import { getAuthList } from '@/api/theme.js'
import { login, logout, getInfo } from '@/api/login'
import { getToken, setToken, removeToken } from '@/utils/auth'

const user = {
    state: {
        token: getToken(),
        name: '',
        avatar: '',
        roles: [],

        userInfo: {
            agent_id: '',
            guid: '',
            merchant_guid: '',
            user_type: ''
        },
        userTitle:"",
        auth: {
            upload: false,
            edit: false,
            message: false
        }
    },

    mutations: {
        SET_AUTH: (state, view) => {
            state.auth = view
        },
        SET_USER_INFO:(state,userInfo)=>{
            state.userInfo = userInfo
        },
        SET_USER_TITLE:(state,userTitle)=>{
            state.userTitle = userTitle
        },
        SET_TOKEN: (state, token) => {
            state.token = token
        },
        SET_NAME: (state, name) => {
            state.name = name
        },
        SET_AVATAR: (state, avatar) => {
            state.avatar = avatar
        },
        SET_ROLES: (state, roles) => {
            state.roles = roles
        }
    },

    actions: {
        setAuth({ commit, state }) {
            // const { user_type, guid } = state.userInfo
            // if (user_type === 'official_staff') {
            //     commit('SET_AUTH', {
            //         upload: true,
            //         edit: true,
            //         message: true
            //     })
            //     return Promise.resolve()
            // }
            // return getAuthList()
            //     .then((res) => {
            //         const upload = res.upload.includes(guid)
            //         const edit = res.edit.includes(guid)
            //         const message = res.message.includes(guid)
            //         commit('SET_AUTH', {
            //             upload,
            //             edit,
            //             message
            //         })
            //     })
            return commit('SET_AUTH', {
                upload: true,
                edit: true,
                message: true
            })
        },
        // 登录
        Login({ commit }, userInfo) {
            const username = userInfo.username.trim()
            return new Promise((resolve, reject) => {
                login(username, userInfo.password).then(response => {
                    const data = response.data
                    setToken(data.token)
                    commit('SET_TOKEN', data.token)
                    resolve()
                }).catch(error => {
                    reject(error)
                })
            })
        },

        // 获取用户信息
        GetInfo({ commit, state }) {
            return new Promise((resolve, reject) => {
                getInfo(state.token).then(response => {
                    const data = response.data
                    commit('SET_ROLES', data.role)
                    commit('SET_NAME', data.name)
                    commit('SET_AVATAR', data.avatar)
                    resolve(response)
                }).catch(error => {
                    reject(error)
                })
            })
        },

        // 登出
        LogOut({ commit, state }) {
            return new Promise((resolve, reject) => {
                logout(state.token).then(() => {
                    commit('SET_TOKEN', '')
                    commit('SET_ROLES', [])
                    removeToken()
                    resolve()
                }).catch(error => {
                    reject(error)
                })
            })
        },

        // 前端 登出
        FedLogOut({ commit }) {
            return new Promise(resolve => {
                commit('SET_TOKEN', '')
                removeToken()
                resolve()
            })
        }
    }
}

export default user



// WEBPACK FOOTER //
// ./src/store/modules/user.js